<template>
  <v-card>
    <v-toolbar color="white" flat>
        <v-toolbar-title class="mx-4">Danh sách tài khoản</v-toolbar-title>
        <v-spacer></v-spacer>
        
        <cfm-dialog :dialog="cfmDialog" :item="selectItem" @close-cfm-dialog="cfmDialog=false, selectItem=null"></cfm-dialog>
        <v-menu
            left
            bottom offset-y
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn outlined color="success" class="ml-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    Hành động<v-icon>mdi-chevron-down</v-icon>
                </v-btn>
            </template>

            <v-list>
            <v-list-item @click="ipDialog=true">
                <v-list-item-icon>
                  <v-icon color="primary" right>mdi-plus</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Thêm phiếu </v-list-item-title>
            </v-list-item>
            </v-list>
        </v-menu>
    </v-toolbar>
    <v-card-text>
      <v-text-field block outlined dense hide-details prepend-inner-icon="mdi-magnify" v-model="search" placeholder="Tìm kiếm"></v-text-field>
      <v-data-table 
        :items="users"
        :headers="headers"
        :search="search"
        :sort-desc="['deptType']"
        @contextmenu:row.prevent="rowRightClickHandler"
      >
      <template v-slot:[`item.actions`]={item}>
        <v-btn color="primary" block @click="cfmDialog=true, selectItem=item" small class="ma-2">Chuyển thiết bị</v-btn>
        <v-btn color="teal" outlined block small class="ma-2" @click="addWebHandler(item)">Chấm công web</v-btn>
        <v-btn color="red" outlined block small class="ma-2" @click="selectItem=item, changePasswordDialog = true">Cập nhật mật khẩu</v-btn>
      </template>
      </v-data-table>

      <!-- right click menu -->
      <!-- <r-click-menu :showMenu="rClickMenu" :x="rClickMenuX" :y="rClickMenuY" @open-ip-dialog="openIpDialogHandler" @close-rclick-menu="rClickMenu=false"></r-click-menu>
      <ip-dialog :show="ipDialog" :form="formIp" :ipList="ipList" :selectItem="selectItem" @close="ipDialog=false"></ip-dialog> -->

    </v-card-text>

    <v-dialog v-model="changePasswordDialog" width="600">
      <v-card>
        <v-card-title>Thay đổi mật khẩu</v-card-title>
        <v-card-text>
          <v-form ref="it_change_password" id="it_change_password" v-model="itChangePasswordValid" @submit.prevent="changePasswordHandler">
            <v-row>
              <v-col cols="12">
                <v-text-field outlined persistent-placeholder hide-details="auto" :rules="[v=>!!v || 'Nhập dữ liệu này']" v-model="changePasswordForm.password" label="Mật khẩu" type="password"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field outlined persistent-placeholder hide-details="auto" :rules="[v=>!!v || 'Nhập dữ liệu này']" v-model="changePasswordForm.confirmPassword" label="Mật khẩu" type="password"></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn type="button" color="red" outlined @click="changePasswordDialog = false">Hủy</v-btn>
          <v-btn type="submit" form="it_change_password" color="success">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import UserService from '../../services/UserService'
import CfmDialog from './CfmDialog.vue'
// import HelpDialog from './HelpDialog.vue'
// import RClickMenu from './RClickMenu.vue'
// import IpDialog from './IpDialog.vue'
export default {
  components:{
    CfmDialog
    // HelpDialog,
    // RClickMenu,
    // IpDialog
  },

  watch: {
    changePasswordDialog(val) {
      if(!val) {
        this.selectItem = {}
        this.changePasswordForm = {
          password: '',
          confirmPassword: '',
          oldPassword:'oldpass'
        }
      }
    }
  },

  data() {
    return {
      users: [],
      selectItem: {},
      search: "",
      headers: [
        {text: 'Mã NS', value: 'employeeCode'},
        {text: 'Tên NS', value: 'employeeName'},
        {text: 'Khối', value: 'departmentTypeName'},
        {text: 'Phòng/Chi nhánh', value: 'departmentName'},
        {text: 'Chức danh', value: 'positionStateName'},
        {text: 'Tài khoản', value: 'userName'},
        {text: 'Trại thái nhân viên', value: 'employeeStatus'},
        {text: 'Trạng thái tài khoản', value: 'userStatus'},
        {text: 'Hành động', value: 'actions'}
      ],

      // menu and dialog
      rClickMenu: false,
      rClickMenuX: 0,
      rClickMenuY: 0,

      //dialog IP
      ipDialog: false,
      ipList: '',
      formIp: {
        ip1: '',
        ip2: '',
        ip3: ''
      },

      //cfmDialog
      cfmDialog: false,

      changePasswordDialog: false,
      itChangePasswordValid: false,
      changePasswordForm: {
        password: '',
        confirmPassword: '',
        oldPassword: 'oldpass'
      }



    }
  },
  methods: {
    rowRightClickHandler(e, select) {
      this.rClickMenuX = e.clientX
      this.rClickMenuY = e.clientY
      this.rClickMenu = true
      this.selectItem = select.item
    },

    openIpDialogHandler() {
      this.ipDialog = true
      this.departmentService.getDeptIp(this.selectItem.code).then(d => {
        this.ipList = d
        let ipArr = this.ipList.split(',')
        this.formIp.ip1 = ipArr[0]
        this.formIp.ip2 = ipArr[1]
        this.formIp.ip3 = ipArr[2]
      })
    },

    closeIpDialogHandler() {
      this.selectItem = {}
      this.ipDialog = false
    },

    addWebHandler(item){
      console.log(item)
      return this.userService.addWeb(item.userCode)
    },

    changePasswordHandler(){
      this.$refs.it_change_password.validate();
      if(this.itChangePasswordValid){
        return this.userService.changePassword(this.selectItem.userCode, this.changePasswordForm).finally(() => {
          this.itChangePasswordValid = false
          this.changePasswordDialog = false
        })
      }
    }
  },

  userService: null,
  created() {
    this.userService = new UserService();
  },
  mounted() {
    this.userService.gets().then(d => this.users=d)
  }
  
}
</script>